import {defineStyleConfig} from '@chakra-ui/styled-system';

import {core} from '../../../design-tokens/light';
import {getCoreValueAsThemeToken} from '../../types';

export const globalActionsStyle = defineStyleConfig({
  baseStyle: {
    border: `none`,
    position: `absolute`,
    right: `0`,
    top: `0`,
    display: `flex`,
    alignItems: `center`,
    background: `lime`,
    p: getCoreValueAsThemeToken(core, `space.space-100`),
    // TODO: use var(--table-header-height)
    height: `32px`,
    gap: getCoreValueAsThemeToken(core, `space.space-050`),
    borderRadius: `var(--table-table-radii)`,
    overflow: `hidden`,
    [`&::before`]: {
      // Disabled for now
      content: `""`,
      position: `absolute`,
      left: `0`,
      top: `0`,
      width: `fit-content`,
      height: `100%`,
      borderRadius: `var(--table-table-radii)`,
      background: `white`,
      boxShadow: `inset 10px 0 4px 4px var(--thead-backgroundColor)`,
    },
  },
});
